<template>
    <div class="dashboard-container">
      <!-- 学员详情 -->
      <div class="body">
        <span class="detail">学员详情</span>
        <!-- <span class="el-icon-circle-close" style="font-size: 28px;" @click="goBack"></span> -->
      </div>
      <div class="app-container">
        <div class="filter-container">
          <div class="headers">
            <el-button type="text" icon="el-icon-edit" @click="cancelStudent">修改信息</el-button>
          </div>
          <div class="dd">
            <span class="realname">{{ studentData.realname }}</span>
          </div>
          <div style="background-color: white;" class="information">
            <el-form :inline="true">
              <el-row>
                <el-col class="bbb" style="width: 70% !important;">
                  <div class="mes">
                    <el-form-item class="course_post">
                      <span slot="label">
                        <span class="formLabel">性别:</span>
                      </span>
                      <span class="form_text">{{ studentData.sex === 1 ? "男" : "女" }}</span>
                    </el-form-item>
                    <el-form-item class="course_post">
                      <span slot="label">
                        <span class="formLabel">年级:</span>
                      </span>
                      <span class="form_text">{{ studentData.gradeStr }}</span>
                    </el-form-item>
                    <el-form-item class="course_post">
                      <span slot="label">
                        <span class="formLabel">联系电话:</span>
                      </span>
                      <span class="form_text">{{ studentData.telephone }}</span>
                    </el-form-item>
                    <el-form-item class="course_post">
                      <span slot="label">
                        <span class="formLabel">家庭住址:</span>
                      </span>
                      <span class="form_text">{{ studentData.address }}</span>
                    </el-form-item>
                  </div>
                  <div style="display: flex; margin-left: 20px;margin-top: -35px;">
                    <!-- <el-form-item label="课消详情:">
                      <span>{{ studentData.planName }}</span>
                    </el-form-item> -->
                    <el-form-item class="course_post">
                      <span slot="label">
                        <span class="formLabel">课消详情:</span>
                      </span>
                      <span class="form_text">{{ studentData.planName }}</span>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>

        <div class="sign">
          <div class="suun">
            <el-form :inline="true">
              <el-form-item label="签约产品" style="float: left; margin-left: 10px; margin-top: 10px">
              </el-form-item>
              <el-form-item style="margin-top: 10px;margin-right: 65px;">
                <el-button size="mini" type="primary" @click="newSigning(id)">新加签约</el-button>
                <el-button size="mini" type="primary" @click="editSigning()">修改签约</el-button>
                <el-button size="mini" type="primary" @click="deleteSigning">删除签约</el-button>
                <el-button size="mini" type="primary" @click="addigning()">添加/修改课消方案</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-divider class="line"></el-divider>
          <!-- 产品列表 -->
          <div class="table">
            <el-table :header-cell-style="{
              background: '#fafafa'
            }" border ref="multipleTable" :data="productData" tooltip-effect="dark" style="width: 100%; margin-top: -8px"
              @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55"> </el-table-column>
              <!-- <el-table-column prop="classType" label="添加日期">
              </el-table-column> -->
              <el-table-column prop="categoryName" label="课程" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="classType" label="班型" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.classType === 1">1v1</span>
                  <span v-if="scope.row.classType === 2">1v2</span>
                  <span v-if="scope.row.classType === 3">1v3</span>
                </template>
              </el-table-column>
              <el-table-column prop="lessonNum" label="课节次数"></el-table-column>
              <el-table-column prop="lessonPrice" label="课时单价">
              </el-table-column>
              <el-table-column prop="teacherName" label="跟进老师">
              </el-table-column>
              <!-- <el-table-column prop="contractName" label="方案名称">
              </el-table-column> -->
              <!-- <el-table-column prop="startTime" label="开始日期">
              </el-table-column>
              <el-table-column prop="endTime" label="有效期至"> </el-table-column> -->
            </el-table>
          </div>
        </div>

        <div class="ft">
          <div class="footer">
            <div class="card">
              <el-tabs v-model="activeName" type="card">
                <el-tab-pane style="float: left;margin-left: 10px;margin-bottom: 15px;" label="课程明细"
                  name="first">课程明细</el-tab-pane>
                <el-tab-pane style="float: left;margin-left: 10px;margin-bottom: 15px;" label="课程统计"
                  name="second">课程统计</el-tab-pane>
              </el-tabs>

              <div class="course" v-show="activeName === 'first'">
                <el-table :data="courseList" border>
                  <el-table-column prop="courstDate" label="课程日期">
                  </el-table-column>
                  <el-table-column prop="courseStartTime" label="开始时间">
                  </el-table-column>
                  <el-table-column prop="courseEndTime" label="结束时间">
                  </el-table-column>
                  <el-table-column prop="courseName" label="课程名称">
                  </el-table-column>
                  <el-table-column prop="courseTeacherName" label="上课老师">
                  </el-table-column>
                  <el-table-column label="结课状态">
                    <template slot-scope="scope">
                      <span>{{ scope.row.classEnding === 1 ? "已结课" : "未结课" }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="deductCourseNum" label="实扣课次" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="classMoney" label="课时费">
                  </el-table-column>
                  <el-table-column prop="classMode" label="上课方式">
                  </el-table-column>
                </el-table>
              </div>
              <div class="course" v-show="activeName === 'second'">
                <el-table :data="countList" border>
                  <!-- <el-table-column type="index"></el-table-column> -->
                  <el-table-column prop="courseName" label="课程名称">
                  </el-table-column>
                  <el-table-column prop="courseTotalNum" label="购买总课次" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="alreadyTotalNum" label="已上课次">
                  </el-table-column>
                  <el-table-column type="expand" label="老师上课节数">
                    <template slot-scope="props">
                      <el-table :data="props.row.teacherCourseInfos" label-position="center" inline
                        class="demo-table-expand">
                        <el-table-column prop="teacherName" label="上课老师">
                        </el-table-column>
                        <el-table-column prop="courseNum" label="课节数">
                        </el-table-column>
                      </el-table>
                    </template>
                  </el-table-column>
                  <el-table-column prop="remainTotalNum" label="剩余课次">
                  </el-table-column>
                  <el-table-column prop="expireTime" label="到期时间">
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>

        <!-- 点击修改信息弹窗 -->
        <el-dialog id="oo" title="修改信息"  :visible.sync="showDialog"  append-to-body	modal-append-to-body :close-on-click-modal="false" :width="'40%'" class="custom-dialog">
          <el-form ref="studentDatas" :model="studentDatas">
            <el-form-item label="姓名" label-width="80px">
              <el-input autocomplete="off" type="text" v-model="studentDatas.realname"></el-input>
            </el-form-item>
            <el-form-item label="性别" label-width="80px">
              <!-- <el-input v-model="studentData.sex"></el-input> -->
              <el-radio-group class="pop" style="" v-model="studentDatas.sex">
                <el-radio label="1">男</el-radio>
                <el-radio label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="年级" style="text-align: left;" label-width="80px">
              <el-cascader clearable v-model="studentDatas.grades" :props="props" :options="gradeList"
                style="width: 100%;"></el-cascader>
            </el-form-item>
            <el-form-item label="联系电话" label-width="80px">
              <el-input maxlength="11" v-model="studentDatas.telephone"></el-input>
            </el-form-item>
            <el-form-item label="家庭住址" label-width="80px">
              <el-input v-model="studentDatas.address"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="showDialog = false" size="small">取 消</el-button>
            <el-button type="primary" size="small" @click="submitForm()">保存</el-button>
          </div>
        </el-dialog>

        <!-- 修改签约产品弹窗 -->
        <el-dialog id="ff" class="dialogClass" title="修改签约产品" :visible.sync="showVisibleDialog" :width="'55%'"
          :append-to-body="true">
          <el-form ref="FormData" :model="FormData">
            <el-form-item label="课程" label-width="80px">
              <!-- <el-input v-model="FormData.categoryId"></el-input> -->
              <el-select class="select" clearable v-model="FormData.categoryId" placeholder="请选择课程" style="width:100%;">
                <el-option v-for="source in courses" :key="source.id" :value="source.id" :label="source.categoryName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="班型" label-width="80px">
              <el-select class="select" clearable v-model="FormData.classType" placeholder="请选择班型" style="width:100%;">
                <el-option v-for="source in lessonList" :key="source.id" :value="source.id" :label="source.name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="跟进老师" label-width="80px">
              <el-select class="select" clearable v-model="FormData.teacherId" placeholder="请选择跟进老师" style="width:100%;">
                <el-option v-for="source in teacherLists" :key="source.id" :value="source.id" :label="source.realname">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="课节数" label-width="80px">
              <el-input v-model="FormData.lessonNum"></el-input>
            </el-form-item>
            <el-form-item label="课时单价" label-width="80px">
              <el-input v-model="FormData.lessonPrice"></el-input>
            </el-form-item>
            <!-- <el-form-item label="签约方案" label-width="80px">
              <el-radio @click.native.prevent="clickitem(item.id)" border v-model="FormData.contractId"
                style="width: 130px; height: 230px; margin-left:10px; margin-bottom: 20px; overflow: auto; max-height: 230px;"
                v-for="(item, index) in planArr" :key="index" :label='item.id'>
                <h3 style="margin-top: 0px;">{{ item.planName }}</h3>
                <div style="text-align: left;" v-for="(item1, index1) in item.planList" :key="index1">
                  <p>课节数:{{ item1.classNum }}</p>
                  <p style="margin-bottom: 20px;">课时单价:{{ item1.classPrice }}</p>
                </div>
              </el-radio>
            </el-form-item> -->
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancel" size="small">取 消</el-button>
            <el-button type="primary" size="small" @click="handleOkClick">保存</el-button>
          </div>
        </el-dialog>



        <el-dialog id="ff" class="dialogClass" title="新增或修改课消方案" :visible.sync="showDing" :width="'55%'"  :append-to-body="true">
        <el-form ref="FormData" :model="FormData" >
          <!-- <el-form-item label="开始日期" label-width="80px">
            <el-date-picker v-model="FormData.startTime" type="date" style="width: 100%;" placeholder="选择日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="有效期至" label-width="80px">
            <el-date-picker v-model="FormData.endTime" type="date" style="width: 100%;" placeholder="选择日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item> -->
          <el-form-item label="课程" label-width="80px" v-if="handle">
            <!-- <el-input v-model="FormData.categoryId"></el-input> -->
            <el-select class="select" clearable v-model="FormData.categoryId" placeholder="请选择课程" style="width:100%;">
              <el-option v-for="source in courses" :key="source.id" :value="source.id" :label="source.categoryName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="班型" label-width="80px"  v-if="handle">
            <el-select class="select" clearable v-model="FormData.classType" placeholder="请选择班型" style="width:100%;">
              <el-option v-for="source in lessonList" :key="source.id" :value="source.id" :label="source.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="跟进老师" label-width="80px"  v-if="handle">
            <el-select class="select" clearable v-model="FormData.teacherId" placeholder="请选择跟进老师" style="width:100%;">
              <el-option v-for="source in teacherLists" :key="source.id" :value="source.id" :label="source.realname">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="课节数" label-width="80px"  v-if="handle">
            <el-input v-model="FormData.lessonNum"></el-input>
          </el-form-item>
          <el-form-item label="课时单价" label-width="80px"  v-if="handle">
            <el-input v-model="FormData.lessonPrice"></el-input>
          </el-form-item>
          <el-form-item label="签约方案" label-width="80px">
            <el-radio @click.native.prevent="clickitem(item.id)" border v-model="FormData.contractId"
              style="width: 130px; height: 230px; margin-left:10px; margin-bottom: 20px; overflow: auto; max-height: 230px;"
              v-for="(item, index) in planArr" :key="index" :label='item.id'>
              <h3 style="margin-top: 0px;">{{ item.planName }}</h3>
              <div style="text-align: left;" v-for="(item1, index1) in item.planList" :key="index1">
                <p>课节数:{{ item1.classNum }}</p>
                <p style="margin-bottom: 20px;">课时单价:{{ item1.classPrice }}</p>
              </div>
            </el-radio>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel1" size="small">取 消</el-button>
          <el-button type="primary" size="small" @click="handleOkClick1">保存</el-button>
        </div>
      </el-dialog>




        <!--新加签约弹窗 -->
        <contract-products ref="contractProducts" :id="id1" @refresh="refresh"></contract-products>
      </div>
    </div>
  </template>

  <script>
  import axios from "axios";
  import apiBaseUrl from "../../../config/api";
  import ContractProducts from "./ContractProducts.vue";
  export default {
    props: ["id"],
    components: {
      ContractProducts //新加产品
      // ModifyProduct //修改产品
    },
    data () {
      return {

        gradeList: [],
        props: {
          label: "gradeName",
          children: "children",
          value: "id"
        },
        teacherLists: [],//所有老师
        id2: "",
        id1: this.id,
        studentData: {
          gradeStr: "",
          progressTeacherName: "",
          realname: "",
          sex: "",
          telephone: "",
          grade: [],
          // grades: [],
          email: "",
          address: "",
          age: "",
          progressTeacherIds: [],
          teacherId: ""
        },
        studentDatas: {
          teacherId: "",//跟进老师
          progressTeacherName: [],
          realname: "",
          sex: "",
          sexStr: "",
          telephone: "",
          // grade: [],
          grades: [],
          email: "",
          address: "",
          age: "",
          progressTeacherIds: []
        },
        salesName: [],
        isShow: false,
        name: "",
        studentList: [],
        list: [], //签约列表
        productData: [],
        prouctCheck: [],
        courseList: [],
        countList: [],
        planArr: [],
        activeName: "first",
        showDialog: false, //修改信息
        dialogVisible: false, //签约产品
        showVisibleDialog: false,
        FormData: {
          contractId: '',
          categoryId: "",
          id: "",
          startTime: "",
          classType: "",
          lessonNum: "",
          lessonPrice: "",
          endTime: "",
          categoryName: "",
          teacherId: ""
        },
        lessonList: [
          {
            id: 1,
            name: "1v1"
          },
          {
            id: 2,
            name: "1v2"
          },
          {
            id: 3,
            name: "1v3"
          }
        ],
        requestParameters: {
          pageSize: 200, //每页多少条
          pageNum: 1, //当前显示页码
        },
        courses: [],
        showDing : 0,
        contractId:"",
        handle:false,
      };
    },
    computed: {
      // jobStatusText () {
      //   return this.studentData.sex + '' === 1 ? "男" : "女";
      // }
    },
    created () {
      // console.log(this.$route.query);
      // console.log(this.$route.params);
      this.allStudent();
      this.getTeacher();
      this.getStudentDetails();
      this.getStudentStatistics();
      this.getProductList();
      this.fetchCourses();
      this.getTeacherList()
      this.getGrade()
      this.getAllPlan()
    },
    methods: {
      cancel1 () {
        this.showDing = false;
      },
      addigning(){
        this.showDing = true
        this.FormData.contractId = this.contractId

      },
      clickitem (val) {
        if (this.FormData.contractId == val) {
          this.FormData.contractId = ""
        } else {
          this.FormData.contractId = val
        }
      },
      //获取所有方案
      getAllPlan () {
        axios
          .post(`${apiBaseUrl}/contract/getList`, this.requestParameters,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
          .then(res => {
            console.log(res.data.data.records);
            this.planArr = res.data.data.records
          })
          .catch(error => {
            console.error(error);
          });
      },
      goBack () {
        history.go(-1)
      },
      //获取年级
      getGrade () {
        axios
          .get(`${apiBaseUrl}/grade/getGrade`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then(res => {
            if (res.data.data.length > 0) {
              this.gradeList = res.data.data;
            } else {
              this.$message({
                message: "获取年级列表失败",
                type: "error"
              });
            }
          })
          .catch(error => {
            console.log(error);
          });
      },
      //获取老师列表
      getTeacherList () {
        axios
          .get(`${apiBaseUrl}/schedule/teacherlist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
          .then(response => {
            this.teacherLists = response.data.data; // 将获取的数据赋值给teachers数组
          })
          .catch(error => {
            console.error(error);
          });
      },
      //查询课程列表
      fetchCourses () {
        axios
          .get(`${apiBaseUrl}/schedule/categorylist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then(response => {
            this.courses = response.data.data;
          })
          .catch(error => {
            console.error(error);
          });
      },
      refresh () {
        this.getProductList();
      },
      //回显学生信息
      allStudent () {
        axios
          .get(`${apiBaseUrl}/student/${this.id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then(res => {

            this.studentData = res.data.data
            this.studentData.sexStr = res.data.data.sexStr + "";
            this.contractId =  res.data.data.contractId
          })
          .catch(err => {
            console.log(err);
          });
      },
      //获取跟进老师
      getTeacher () {
        axios
          .get(`${apiBaseUrl}/teacher/teacherList`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then(response => {
            this.salesName = response.data.data;
          })
          .catch(error => {
            console.error(error);
          });
      },
      //点击修改信息
      cancelStudent () {
        this.showDialog = true;
        axios
          .get(`${apiBaseUrl}/student/${this.id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then(res => {
            this.studentDatas = res.data.data;
            this.studentDatas.sex = res.data.data.sex + "";
            this.studentDatas.grades = JSON.parse(res.data.data.grade)
          })
          .catch(err => {
            console.log(err);
          });
      },
      //修改学生保存信息
      submitForm () {
        axios
          .post(`${apiBaseUrl}/student/modify/${this.id}`, this.studentDatas,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then(res => {
            this.$message({ message: "更新成功", type: "success" });
            // console.log(JSON.stringify(this.studentDatas));
            this.allStudent();
            this.showDialog = false;
          })
          .catch(err => {
            this.$message.error("更新失败");
          });
      },
      //选中事件
      handleSelectionChange (arr) {
        // console.log(arr);
        const aa = [];
        for (let i = 0; i < arr.length; i++) {
          aa.push(arr[i].id);
          // 拿到选中行的产品id
          this.id2 = arr[i].id;
        }
        // this.prouctCheck = this.aa;
        this.prouctCheck = aa;
      },
      //查询产品列表
      getProductList () {
        axios
          .get(`${apiBaseUrl}/product/getList/${this.id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then(response => {
            this.productData = response.data.data;
          })
          .catch(error => {
            console.error(error);
          });
      },
      //点击新加签约按钮
      newSigning () {
        this.$nextTick(() => {
          this.$refs.contractProducts.init();
        });
      },
      //修改签约按钮
      editSigning () {

        if (!this.prouctCheck || this.prouctCheck.length === 0) {
          this.$message.error("请先选择要修改的产品");
          return;
        }

        if (!this.prouctCheck || this.prouctCheck.length !== 1) {
          this.$message.error("请选择且只能选择一个产品");
          return;
        }
        this.showVisibleDialog = true;
        axios
          .get(`${apiBaseUrl}/product/getById/${this.id2}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then(res => {
            this.FormData = res.data.data
          })
          .catch(err => {
            this.$message({ message: res.data.message, type: "error" });
            console.log(err);
          });
      },

      handleOkClick1(){
      const data = {
        contractId: this.FormData.contractId,
      };
      axios.put(`${apiBaseUrl}/student/modifyPlan/${this.id}`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then(res => {
          this.$message({ message: "更新成功", type: "success" });
          this.showVisibleDialog = false;
          this.showDing = false;

          this.allStudent();
      this.getTeacher();
      this.getStudentDetails();
      this.getStudentStatistics();
      this.getProductList();
      this.fetchCourses();
      this.getTeacherList()
      this.getGrade()
      this.getAllPlan()
        })
        .catch(err => {
          this.$message.error("更新失败");
        });
    },

      //修改签约保存
      handleOkClick () {
        const data = {
          categoryId: this.FormData.categoryId,
          id: this.id2,
          studentId:this.id,
          contractId: this.FormData.contractId,
          classType: this.FormData.classType,
          lessonNum: this.FormData.lessonNum,
          lessonPrice: this.FormData.lessonPrice,
          endTime: this.FormData.endTime,
          startTime: this.FormData.startTime,
          teacherId: this.FormData.teacherId
        };
        axios
          .post(`${apiBaseUrl}/product/update`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then(res => {
            // console.log(res, "kkkkkkkkkkkkkkkkkkk");
            this.$message({ message: "更新成功", type: "success" });
            this.showVisibleDialog = false;
            this.getProductList();
          })
          .catch(err => {
            this.$message.error("更新失败");
          });
      },
      deleteSigning () {
        if(this.productData.length <= 1){
          this.$message.error("学生绑定的方案必须存在一条不可删除");
          return;
        }


        // console.log(this.prouctCheck,'点我点我');
        if (!this.prouctCheck || this.prouctCheck.length === 0) {
          this.$message.error("请先选择要删除的产品");
          return;
        }
        axios
          .post(`${apiBaseUrl}/product/deleteByIds`, { ids: this.prouctCheck },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then(response => {
            console.log(response.data.data);
            if (response.data.code === 200) {
              this.$message.success("删除成功");
              // // 更新列表数据
              this.getProductList();
            } else {
              this.$message({ message: res.data.message, type: "error" });
            }
          })
          .catch(error => {
            console.log(error);
          });
      },
      //获取课程明细
      getStudentDetails () {
        axios
          .get(`${apiBaseUrl}/student/student_details/${this.id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then(res => {

            this.courseList = res.data.data;
          })
          .catch(err => {
            console.log(err);
          });
      },
      //获取课程统计
      getStudentStatistics () {
        axios
          .post(`${apiBaseUrl}/student/student_course_count/${this.id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then(res => {
            this.countList = res.data.data;
            console.log(res.data.data, "1");
          })
          .catch(err => {
            console.log(err);
          });
      },
      showEditDialog () {
        this.edit();
      },
      cancel () {
        this.showVisibleDialog = false;
      }
    }
  };
  </script>

  <style scoped>

  .body {

    /* display: flex; */
    background-color: #fff;
    height: 40px;
    line-height: 40px;
    text-align: center;
    /* align-items: center;
    justify-content: space-between; */
    margin-bottom: 10px;
  }

  .detail {
    /* float: left;
    margin-left: 10px; */
    font-size: 22px;

  }

  .header {
    background-color: #fafafa;
    border: 1px solid #e1e1e1;
    margin-top: 10px;
  }

  .headers {
    background-color: #fafafa;
    border: 1px solid #e1e1e1;
    /* margin-top: 10px; */
    text-align: center;
    font-size: 20px;
    margin-bottom: 10px;
  }

  .headerss {
    background-color: #fafafa;
    border: 1px solid #e1e1e1;
    height: 40px;
    line-height: 40px;
    margin-top: 10px;
    font-weight: 500;
  }

  .footer {
    /* background-color: #fff; */
    margin-top: 10px;
    /* height: 300px; */
  }

  .ft {
    background-color: #fff;
    /* height: 500px; */
  }

  .stu {
    margin-left: 10px;
    margin-right: 10px;
  }

  .deep {
    background-color: #fff;
    margin-top: 10px;
    height: 300px;
  }

  .course {
    margin-left: 10px;
    margin-right: 10px;
  }

  .name-link {
    text-decoration: none;
    /* 这将移除下划线 */
  }

  .sub {
    border: 1px solid #e1e1e1;
    height: 55px;
  }

  .realname {
    font-size: 20px;
    font-weight: 600;
    color: #fff;
  }

  /* .card {
    height: 40px;
  }
   */
  .dd {
    float: left;
    border-radius: 50px;
    width: 80px;
    height: 80px;
    line-height: 80px;
    background-color: #1c86ee;
    margin-left: 15px;
    /* margin-top: -25px; */
    margin-right: 20px;
    text-align: center;
  }

  .bbb {
    width: 70%;
  }

  .mes {
    display: flex;
    margin-left: 20px;
    white-space: nowrap;
    padding-top: 20px;
  }

  .table {
    margin-left: 10px;
    margin-right: 10px;
  }

  .sign {
    background-color: #fff;
    margin-top: 10px;
    /* height: 700px; */
  }

  .line {
    margin-top: -16px;
  }

  /* 兼容移动端 */
  @media screen and (max-width: 750px) {
    .dashboard-container {
      /* overflow: auto; */
      width: 1430px;
    }

    /* 兼容移动端 */
    #oo>>>.el-dialog {
      width: 70% !important;
    }

    .pop {
      margin-left: -15% !important;
    }

    #ff>>>.el-dialog {
      width: 70% !important;
    }
  }

  </style>
  <style scoped lang="less">
  /deep/.dia{
    height: 100vh;
    background-color: #fff;
  }
  .formLabel{
    font-size: 20px;
    font-weight: 700;
  }
  .form_text{
    font-size: 16px;
    font-weight: 700;
  }
  .course_post{
    margin-left: 20px;
  }
  </style>



// WEBPACK FOOTER //
// src/manager/components/scheduDetadia.vue